import axios from 'axios';
import { API } from 'common-http/index';

const { ApiAction } = require('./common');

async function getI18NData(id, lang) {
  return await API.commonHttpCall({
    fullPath: ApiAction.getTranslate,
    data: {
      method: 'get',
      params: { lang, id },
    },
    // options: { notHandleError: true },
  }).then((res) => {
    return res?.data?.data || '{}';
  });
}

export default async function request(id, lang) {
  const i18nDataRes = await getI18NData(id, lang);
  const i18nDataCdn = i18nDataRes.data || i18nDataRes;
  if (!i18nDataCdn) {
    return '{}';
  }
  return await axios.get(i18nDataCdn).then(async (res) => {
    const reg = new RegExp('(?<=\\{"\\d+":).+(?=\\}\\))', 'g');
    const resMatch = res?.data?.match(reg);
    return resMatch && resMatch.length > 0 ? resMatch[0] : '{}'; // 如果data为空，返回 '{}' ，这是避免 JSON.parse 报错
  });
}
